import api from '@/services/api/api';

export const useAudioLecturesBySlug = (slug) => {
  const audioLecture = useQuery(
    ['audioLecture', slug],
    async () => {
      const { data } = await api.lectures.getAudioLectureBySlug(slug);
      return data;
    },
    {
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await audioLecture.suspense();
  });

  return {
    audioLecture,
  };
};
